let one_time_products = ''
let sub_products = ''
let selected_option = 'one_time';
let bundle_cache = {};
let bundle_information_promise = null;

function changeCoupon(which_option, force_remove) {
    let inline_coupon = retrieveOptionCoupon(which_option);
    let d_url = new URL(window.location.href);
    let d_params = d_url.searchParams;
    if(inline_coupon && (typeof force_remove === 'undefined')) {
        d_params.set('coupon', inline_coupon);
    }
    else {
        d_params.delete('coupon');
    }
    window.history.replaceState({}, document.title, d_url.href);
}
function changeLinks(which_option) {
    let buttons = document.querySelectorAll('.redirect_to_checkout');
    let doc_url = new URL(window.location.href);
    let doc_params = doc_url.searchParams;
    let checkout_link = '';
    if (which_option === 'one_time') {
        checkout_link = new URL(one_time_url);
        selected_option = 'one_time';
    } else if (which_option === 'sub') {
        checkout_link = new URL(sub_url);
        selected_option = 'sub';
    }
    let checkout_params = checkout_link.searchParams;
    doc_params.forEach((v, k) => {
        checkout_params.set(k, v);
    });
    buttons.forEach(button => {
        button.href = checkout_link.href;
    });
}
function changeClasses(which_option) {
    let toggles = document.querySelectorAll('.toggle-subscription-option');
    let select_sub = (which_option === 'sub');
    toggles.forEach(toggle => {
        let is_sub = toggle.classList.contains('is_subscription');
        if((select_sub && is_sub) || (!select_sub && !is_sub)) {
            toggle.classList.add('selected');
        }
        else {
            toggle.classList.remove('selected');
        }
    });
}
function retrieveOptionCoupon(which_option) {
    let c_parts = []
    if ((which_option === 'one_time') && (one_time_url.indexOf('coupon=') > -1)) {
        c_parts = one_time_url.split('coupon=');
    } else if ((which_option === 'sub') && (sub_url.indexOf('coupon=') > -1)) {
        c_parts = sub_url.split('coupon=');
    }
    if(Array.isArray(c_parts) && (c_parts.length > 1)) {
        return c_parts[1];
    }
    return '';
}
function retrieveBundleInformation(which_option) {
  if(!which_option) {
    return Promise.resolve(null);
  }    
  // If we have cached data, return it immediately
  if(typeof bundle_cache[which_option] !== 'undefined') {
    return Promise.resolve(bundle_cache[which_option]);
  }    
  // If a request is already in progress, return that promise
  if(bundle_information_promise) {
    return bundle_information_promise;
  }    
  // Create a new request
  let request_url = 'https://try.noobru.com/checkout-information/bundle/';
  let bundle_url = (which_option === 'sub') ? sub_url : one_time_url;
  let bundle_slug_parts = bundle_url.split('bundle/');
  if(Array.isArray(bundle_slug_parts) && (bundle_slug_parts.length > 1)) {
    request_url = request_url + bundle_slug_parts[1];
  }
  else {
    return Promise.resolve(null);
  }
  
  bundle_information_promise = fetch(request_url)
    .then(function(response) { return response.json(); })
    .then(function(r) {
      bundle_cache[which_option] = r?.info || r;
      bundle_information_promise = null; // Clear the promise tracker
      return r?.info || r || null;
    })
    .catch(function(error) {
      bundle_information_promise = null; // Clear on error too
      throw error;
    });  
  return bundle_information_promise;
}
function setSelectedOption(which_option) {
    retrieveBundleInformation(which_option)
    .then((bundle_information) => {
        if(bundle_information && bundle_information.variant_ids_and_quantity) {
            if (which_option === 'one_time') {
                one_time_products = bundle_information.variant_ids_and_quantity;
            } else if (which_option === 'sub') {
                sub_products = bundle_information.variant_ids_and_quantity;
            }
        }
        changeLinks(which_option);
        changeClasses(which_option);
        changeCoupon(which_option);
        changePrices(which_option);
    });
}
function changePrices(which_option) {
    let prices_str = ''
    if (which_option === 'one_time') {
        prices_str = one_time_products.replaceAll(':1:1', ':1');
    } else if (which_option === 'sub') {
        prices_str = sub_products.replaceAll(':1:1', ':1');
    }
    if(prices_str) {
        let price_elements = document.querySelectorAll('[data-multiple-prices]');
        let changed_elements = 0;
        price_elements.forEach(element => {
            if(element.dataset.multiplePrices !== prices_str) {
                element.setAttribute('data-multiple-prices', prices_str);
                //element.setAttribute('data-coupon', inline_coupon);
                element.removeAttribute('data-exchanged-to');
                changed_elements++;
            }
        });
        if(changed_elements) {
            document.documentElement.dispatchEvent(new CustomEvent('effic:exchange_multiple_prices', {
                bubbles: true
            }))
        }
    }
}
function addToCart() {
    let products = []
    if (selected_option === 'one_time') {
      products = one_time_products.split(',').map(product => {
        let parts = product.split(':')
        return {
          'id': parts[0],
          'quantity': parts[1]
        }
      });
    } else if (selected_option === 'sub') {
      products = sub_products.split(',').map(product => {
        let parts = product.split(':')
        return {
          'id': parts[0],
          'quantity': parts[1]
        }
      });
    }
    let formData = {'items': products}
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(r => {
      if(typeof r.items != 'undefined') {
        updateCart(r.items.map(l => {
          let line = {}
          line[l.id] = l.quantity
          return line
        }))
      }
    })
    .catch((error) => {
      console.error('addToCart Failed with the following error:', error);
    });
  }
  
  function updateCart(items) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then(response => {
      return response.json();
    })
    .then(r => {
      if(typeof r.items != 'undefined') {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }))
        const cart_drawer = document.querySelector('.cart-drawer');
        if(cart_drawer) {
          cart_drawer.show();
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
  }

if (typeof bundle_out_of_stock === 'undefined' || !bundle_out_of_stock) {
  setSelectedOption('sub');
}

document.addEventListener("visibilitychange", () => {
  if (document.hidden) {
    retrieveOptionCoupon(selected_option, true);
  }
});
